// extracted by mini-css-extract-plugin
export default {"icon":"Icons_icon__-KXdn","fill":"Icons_fill__dz5k3","stroke":"Icons_stroke__5KFPn","thin":"Icons_thin__K-Ftx","transform":"Icons_transform__StVbW","lottie":"Icons_lottie__EDiUY"};